export default {"src":"/_next/static/media/skl.274ee7ad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};